// Cancel the navigation if the full translation suite is active
export default defineNuxtRouteMiddleware(() => {
  const localeStore = useLocaleStore()
  if (localeStore.fullTranslationSuiteActive) {
    return false
  }
  return true
})
